import React, { ReactNode } from "react";

import { TextFieldProps } from "@mui/material";
import { AsyncAutocomplete } from "components/forms";
import { useActionHook } from "hooks";
import { useDealActions } from "store";

export interface CompanyAutocompleteProps {
  onChange: (value: string) => void;
  className?: TextFieldProps["className"];
  sx?: TextFieldProps["sx"];
  investmentId: number;
  charName: string;
  defaultValue?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: ReactNode;
}

export const CompanyAutocomplete: React.FC<CompanyAutocompleteProps> = ({
  onChange,
  investmentId,
  charName,
  ...props
}) => {
  const { getInvestmentValuesAction } = useDealActions();

  const { data, loading, action, resetData } = useActionHook(getInvestmentValuesAction);

  return (
    <AsyncAutocomplete
      label={charName}
      onChange={(value: string) => {
        onChange(value);
        if (data?.length) {
          resetData();
        }
      }}
      fetchData={(s: string) => action(s, investmentId)}
      options={data}
      loading={loading}
      {...props}
    />
  );
};
